'use strict';

window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function pageLinkFocus($element) {
    var focusClass = 'js-focus-hidden';

    $element.first().attr('tabIndex', '-1').focus().addClass(focusClass).one('blur', callback);

    function callback() {
      $element.first().removeClass(focusClass).removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function focusHash() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function bindInPageLinks() {
    $('a[href*=#]').on('click', function (evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function trapFocus(options) {
    var eventName = options.eventNamespace ? 'focusin.' + options.eventNamespace : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function (evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function removeTrapFocus(options) {
    var eventName = options.namespace ? 'focusin.' + options.namespace : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {

  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function cookiesEnabled() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled) {
      document.cookie = 'testcookie';
      cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function findInstance(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function removeInstance(array, key, value) {
    var i = array.length;
    while (i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function compact(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function defaultTo(value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

slate.rte = {

  wrapTable: function wrapTable() {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function iframeReset() {
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function () {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="rte__video-wrapper"></div>');
    });

    $iframeReset.each(function () {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document).on('shopify:section:load', this._onSectionLoad.bind(this)).on('shopify:section:unload', this._onSectionUnload.bind(this)).on('shopify:section:select', this._onSelect.bind(this)).on('shopify:section:deselect', this._onDeselect.bind(this)).on('shopify:section:reorder', this._onReorder.bind(this)).on('shopify:block:select', this._onBlockSelect.bind(this)).on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function _createInstance(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function _onSectionLoad(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function _onSectionUnload(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function _onSelect(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function _onDeselect(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function _onReorder(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function _onBlockSelect(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function _onBlockDeselect(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function register(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function (index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
}();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = function () {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
}();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = function () {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function _getCurrentOptions() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function (element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function _getVariantFromOptions() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function (variant) {
        var satisfied = true;
        var options = variant.options;

        selectedValues.forEach(function (option) {
          if (satisfied) {
            satisfied = option.value === variant[option.index];
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function _onSelectChange() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function _updateImages(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function _updatePrice(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function _updateHistoryState(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({ path: newurl }, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function _updateMasterSelect(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
}();

/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = function () {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]',
    productRestrictedDelivery: '[data-product-restricted-delivery]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);
    var sectionId = this.$container.attr('data-section-id');

    this.settings = {};
    this.namespace = '.product';

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());
    this.settings.imageSize = slate.Image.imageSize($(selectors.productFeaturedImage, this.$container).attr('src'));

    slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

    this.initVariants();
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Handles change events from the variant inputs
     */
    initVariants: function initVariants() {
      var options = {
        $container: this.$container,
        enableHistoryState: this.$container.data('enable-history-state') || false,
        singleOptionSelector: selectors.singleOptionSelector,
        originalSelectorId: selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.variants = new slate.Variants(options);

      this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
      this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));
    },

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabeled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function updateAddToCartState(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function updateProductPrices(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container).html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function updateProductImage(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      $(selectors.productFeaturedImage, this.$container).attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function onUnload() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
}();

$(document).ready(function () {

  var faqNav = document.querySelector('.faq-nav__full');
  var headerMarketing = document.querySelector('.header-marketing');
  if (faqNav) {
    var fixFaqNav = function fixFaqNav() {
      if (headerMarketing) {
        var bottomOfHeaderMarketing = headerMarketing.offsetHeight;
        var totalFixHeader = faqNav.offsetHeight + bottomOfHeaderMarketing;
        if (window.pageYOffset >= topOfFaqNav - bottomOfHeaderMarketing) {
          faqNav.classList.add('faq-nav__fixed');
          faqNav.style.top = bottomOfHeaderMarketing + 'px';
          document.body.style.paddingTop = faqNav.offsetHeight + 'px';
        } else {
          faqNav.classList.remove('faq-nav__fixed');
          faqNav.style.top = '0px';
          document.body.style.paddingTop = 0;
        }
      } else {
        if (window.pageYOffset >= topOfFaqNav) {
          faqNav.classList.add('faq-nav__fixed');
          document.body.style.paddingTop = faqNav.offsetHeight + 'px';
        } else {
          faqNav.classList.remove('faq-nav__fixed');
          document.body.style.paddingTop = 0;
        }
      }
    };

    var topOfFaqNav = faqNav.offsetTop;

    window.addEventListener('scroll', fixFaqNav);
  }

  // Scrollspy mobile dropdown
  $('.faq-nav--mobile').click(function () {
    $('.faq-nav--dropdown').toggleClass('faq-nav--open');
  });

  $('.faq-nav a').on("click", function () {
    $('.faq-nav--dropdown').removeClass('faq-nav--open');
  });
});

function getOrderProducts(link) {
  var orderId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  event.preventDefault ? event.preventDefault() : event.returnValue = false;
  $.ajax({
    url: link + '?view=modal',
    success: function success(html) {
      var modalContainer = document.querySelector('.order-history__modal-container');
      modalContainer.innerHTML = html;
    },
    complete: function complete(response) {
      var overlay = document.querySelector('.overlay');
      var modal = document.querySelector('.details-modal');
      var modalBody = document.querySelector('.details-modal__body');
      modal.classList.add('details-modal-active');
      overlay.classList.add('overlay-active');

      if (orderId) {
        window.mountReorderButton && window.mountReorderButton(orderId);
      }

      var close = document.querySelector('.close-modal');
      if (close) {
        close.addEventListener('click', closeModal);
      }
    }
  });
}

function closeModal() {
  var overlay = document.querySelector('.overlay');
  var modal = document.querySelector('.details-modal');
  var modalBody = document.querySelector('.order-history__modal-container');
  modal.classList.remove('details-modal-active');
  overlay.classList.remove('overlay-active');
  modalBody.innerHTML = '';
}

(function () {

  'use strict';

  /**
   * tabs
   *
   * @description The Tabs component.
   * @param {Object} options The options hash
   */

  var tabs = function tabs(options) {

    var el = document.querySelector(options.el);
    var tabNavigationLinks = el.querySelectorAll(options.tabNavigationLinks);
    var tabContentContainers = el.querySelectorAll(options.tabContentContainers);
    var activeIndex = 0;
    var initCalled = false;

    /**
     * init
     *
     * @description Initializes the component by removing the no-js class from
     *   the component, and attaching event listeners to each of the nav items.
     *   Returns nothing.
     */
    var init = function init() {
      if (!initCalled) {
        initCalled = true;
        el.classList.remove('no-js');

        for (var i = 0; i < tabNavigationLinks.length; i++) {
          var link = tabNavigationLinks[i];
          handleClick(link, i);
        }
      }
    };

    /**
     * handleClick
     *
     * @description Handles click event listeners on each of the links in the
     *   tab navigation. Returns nothing.
     * @param {HTMLElement} link The link to listen for events on
     * @param {Number} index The index of that link
     */
    var handleClick = function handleClick(link, index) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        goToTab(index);
      });
    };

    /**
     * goToTab
     *
     * @description Goes to a specific tab based on index. Returns nothing.
     * @param {Number} index The index of the tab to go to
     */
    var goToTab = function goToTab(index) {
      if (index !== activeIndex && index >= 0 && index <= tabNavigationLinks.length) {
        tabNavigationLinks[activeIndex].classList.remove('is-active');
        tabNavigationLinks[index].classList.add('is-active');
        tabContentContainers[activeIndex].classList.remove('is-active');
        tabContentContainers[index].classList.add('is-active');
        activeIndex = index;
      }
    };

    /**
     * Returns init and goToTab
     */
    return {
      init: init,
      goToTab: goToTab
    };
  };

  /**
   * Attach to global namespace
   */
  window.tabs = tabs;
})();

document.addEventListener('DOMContentLoaded', function () {

  var yfForms = document.querySelectorAll('.yf-form');
  var activeSelect = void 0;

  // Use capture to get values before they're set
  document.addEventListener('click', documentClickHandler, true);

  // Look for all custom forms
  yfForms.forEach(function (yfForm) {
    // Text elements
    var inputs = yfForm.querySelectorAll('.yf-text input, .yf-text textarea, .yf-select input');
    inputs.forEach(function (el) {
      el.addEventListener('focus', inputFocusHandler);
      el.addEventListener('blur', inputBlurHandler);
      inputBlurHandler.call(el);
    });

    var selects = yfForm.querySelectorAll('select');
    selects.forEach(function (el) {
      el.addEventListener('change', inputBlurHandler);
      inputBlurHandler.call(el);
    });

    // Select elements
    var yfSelects = yfForm.querySelectorAll('.yf-select');
    yfSelects.forEach(function (el) {
      el.addEventListener('click', selectClickHandler);
      // Capture on keydown so we prevent default behaviour
      el.addEventListener('keydown', selectKeyHandler);
    });

    var displays = yfForm.querySelectorAll('.yf-select__display');
    displays.forEach(function (el) {
      el.addEventListener('focus', displayFocusHandler);
      el.addEventListener('blur', displayBlurHandler);
    });

    // Search elements
    var searchInputs = yfForm.querySelectorAll('.yf-select--search input');
    searchInputs.forEach(function (el) {
      el.addEventListener('keyup', searchKeyupHandler);
    });

    var radios = yfForm.querySelectorAll('.yf-radio-group input');
    radios.forEach(function (el) {
      el.addEventListener('change', radioChangeHandler);
    });

    var checkboxes = yfForm.querySelectorAll('.yf-checkbox-group input');
    checkboxes.forEach(function (el) {
      el.addEventListener('change', checkboxChangeHandler);
    });
  });

  /**
   * Text input focus handler
   */
  function inputFocusHandler() {
    this.parentElement.classList.add('filled');
  }

  /**
   * Text input blur handler
   */
  function inputBlurHandler(e) {
    // Check validity if this was fired from an event
    if (e) {
      // Check if input passed HTML5 validity based on given attributes
      if (this.checkValidity()) {
        this.parentElement.classList.add('success');
        this.parentElement.classList.remove('failure');
      } else {
        this.parentElement.classList.add('failure');
        this.parentElement.classList.remove('success');
      }
    }
    // Check the input has a value
    if (this.value === '') {
      //remove success from unrequired inputs
      this.parentElement.classList.remove('filled', 'success');
    } else {
      this.parentElement.classList.add('filled');
    }
  }

  /**
   * Handles an input's focus event
   */
  function displayFocusHandler() {
    this.parentElement.classList.add('focus');
  }

  /**
   * Handles an input's blur event
   */
  function displayBlurHandler() {
    this.parentElement.classList.remove('focus');
  }

  /**
   * Opens the select list
   */
  function activateSelect(select) {
    select.classList.add('active');
    activeSelect = select;
  }

  /**
   * Selects an option
   */
  function selectOption(select, option) {

    var isSearch = select.classList.contains('yf-select--search');

    select.classList.remove('active');
    select.classList.add('filled');
    activeSelect = null;

    if (isSearch) {
      select.classList.add('updated');
    } else {
      // Update selected state on options list
      var selected = select.querySelector('.selected');
      if (selected) selected.classList.remove('selected');
      option.classList.add('selected');
      // Update display
      var display = select.querySelector('.yf-select__display');
      display.innerHTML = option.innerHTML;
    }
    // Update value
    var input = select.querySelector('input');
    input.value = option.dataset.option;
  }

  /**
   * Functionality for a custom slect element
   */
  function selectClickHandler(e) {

    var target = e.target;
    var select = target.parents('.yf-select');
    var option = target.parents('.yf-select__option');

    if (target.tagName === 'LABEL' || target.tagName === 'INPUT' || target.tagName === 'DIV') {
      // The display part of the select element was clicked
      activateSelect(select);
    } else if (option) {
      // An option was clicked
      selectOption(select, option);
    }
  }

  /**
   * Handles functionality for custom select boxes
   */
  function selectKeyHandler(e) {

    var keyCode = e.keyCode || e.which;
    var target = e.target;
    var select = target.parents('.yf-select');
    var focusable = select.querySelectorAll('input[type="text"], [tabindex]:not([style])');
    var tabindex = Array.from(focusable).indexOf(document.activeElement);

    switch (keyCode) {
      case 27:
        // esc - closes list
        select.classList.remove('active');
        activeSelect = null;
        focusable[0].focus();
        e.preventDefault();
        break;
      case 13:
      case 32:
        // Enter, Space - opens list and selects option/close list
        if (target.matches('.yf-select__option')) {
          selectOption(select, target);
          focusable[0].focus();
        } else {
          activateSelect(select);
          focusable[1].focus();
        }
        e.preventDefault();
        break;
      case 38:
        // Up - move down
        if (tabindex > 0) {
          if (tabindex === 1) {
            select.classList.remove('active');
            activeSelect = null;
          }
          focusable[tabindex - 1].focus();
        }
        e.preventDefault();
        break;
      case 40:
        // Down - move up
        if (tabindex < focusable.length - 1) {
          if (tabindex === 0) {
            activateSelect(select);
          }
          focusable[tabindex + 1].focus();
        }
        e.preventDefault();
        break;
    }
  }

  /**
   * Handles the searching of the search list
   */
  function searchSearchList(searchList) {

    var searchInput = searchList.querySelector('input');
    var searchTerm = searchInput.value;
    var items = searchList.querySelectorAll('li');
    var searchExp = new RegExp('(' + searchTerm + ')', 'i');

    // Show/hide the options (if a selection wasn't just made)
    if (searchList.classList.contains('updated')) {
      setTimeout(function () {
        searchList.classList.remove('updated');
      }, 1000);
    } else {
      if (searchTerm.length > 0) {
        searchList.classList.add('active');
      } else {
        searchList.classList.remove('active');
      }
    }

    // Filter the options
    items.forEach(function (item) {

      var span = item.querySelector('span');
      var text = item.dataset.option;

      if (searchExp.test(text)) {
        span.innerHTML = text.replace(searchExp, "<b>$1</b>");
        item.removeAttribute('style');
      } else {
        // Return the original text and hide the block
        span.innerText = text;
        item.style.display = 'none';
      }
    });
  }

  /**
   * keyup handler for search list element
   */
  function searchKeyupHandler() {
    searchSearchList(this.parentElement);
  }

  /**
   * Adds selected class to radio/checkbox parent
   */
  function radioChangeHandler() {

    var parent = this.parents('.yf-radio-group');
    var radios = parent.querySelectorAll('input');

    radios.forEach(function (el) {
      if (el.checked) {
        el.parentElement.classList.add('selected');
      } else {
        el.parentElement.classList.remove('selected');
      }
    });
  }

  /**
   * Adds selected class to radio/checkbox parent
   */
  function checkboxChangeHandler() {

    if (this.checked) {
      this.parentElement.classList.add('selected');
    } else {
      this.parentElement.classList.remove('selected');
    }
  }

  /**
   * Handles captured document click - eg. close select elements
   */
  function documentClickHandler(e) {

    var target = e.target;
    var select = target.parents('.yf-select');

    // Is the target the active select element?
    if (select && select === activeSelect) return;

    var selects = document.querySelectorAll('.yf-select');
    selects.forEach(function (el) {
      return el.classList.remove('active');
    });
    activeSelect = null;
  }
});

/**
 * Look up the element tree and try to match the selector
 * Similar to jQuery's parents method
 */
Element.prototype.parents = function (selector) {

  var current = this;

  while (current.parentNode != null && current.parentNode != document.documentElement) {
    if (current?.parentNode?.matches(selector)) {
      return current.parentNode;
    }
    current = current.parentNode;
  }
};

// Element.matches()
if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function (s) {
    var matches = (this.document || this.ownerDocument).querySelectorAll(s),
        i = matches.length;
    while (--i >= 0 && matches.item(i) !== this) {}
    return i > -1;
  };
}

// Nodelist.forEach()
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = function (callback, argument) {
    argument = argument || window;
    for (var i = 0; i < this.length; i++) {
      callback.call(argument, this[i], i, this);
    }
  };
}

/**
*	Toggles mobile menu drawer
**/
function toggleMenuDrawer(evt) {
  if (evt) {
    evt.preventDefault();
  }
  var bodyEl = document.querySelector('body');
  bodyEl.classList.toggle('mobilemenu--active');
}

$(document).ready(function () {
  var mobilemenuBtns = document.querySelectorAll('.js-mobile-menu');
  var drawerOverlay = document.querySelector('.drawer-overlay');

  if (drawerOverlay) {
    drawerOverlay.addEventListener('click', toggleMenuDrawer);
  }
  if (mobilemenuBtns) {
    $.each(mobilemenuBtns, function (i, btn) {
      btn.addEventListener('click', toggleMenuDrawer);
    });
    // updateAjaxCart();
  }

  $(function () {
    $('.overlay-home-video__learn-more a').on('click', function (e) {
      e.preventDefault();
      $('html, body').animate({ scrollTop: $($(this).attr('href')).offset().top }, 1000, 'ease');
    });
  });
});
//Cache reference to window and animation items
var $animation_elements = $('.slide-in');
var $boxes = $('.our-range--box');
var $floatingElements = $('.parallex');
var $window = $(window);

var lastScrollTop = 0;

var position = 0;

function check_if_in_view() {
  var window_height = $window.height();
  var window_top_position = $window.scrollTop();
  var window_bottom_position = window_top_position + window_height;

  if ($boxes) {
    $.each($boxes, function () {
      var $element = $(this);
      var element_height = $element.outerHeight();
      var element_top_position = $element.offset().top;
      var element_bottom_position = element_top_position + element_height;

      if (element_bottom_position >= window_top_position && element_top_position <= window_bottom_position) {
        $element.addClass('in-view');
      } else {
        $element.removeClass('in-view');
      }
    });
  }

  $.each($animation_elements, function () {
    var $element = $(this);
    var element_height = $element.outerHeight();
    var element_top_position = $element.offset().top;
    var element_bottom_position = element_top_position + element_height;

    //check to see if this current container is within viewport
    if (element_bottom_position >= window_top_position && element_top_position <= window_bottom_position) {
      $element.addClass('in-view');
    } else {
      $element.removeClass('in-view');
    }
  });

  if ($floatingElements) {
    var st = window.pageYOffset || document.documentElement.scrollTop;
    if (st > lastScrollTop) {
      $.each($floatingElements, function () {
        var $element = $(this);
        var element_height = $element.outerHeight();
        var element_top_position = $element.offset().top;
        var element_bottom_position = element_top_position + element_height;

        if (element_bottom_position >= window_top_position && element_top_position <= window_bottom_position) {
          position = position - 0.5;
          $element.css('transform', 'translateY(' + position + 'px)');
        } else {
          $element.css('transform', 'translateY(0px)');
        }
      });
    } else {
      $.each($floatingElements, function () {
        var $element = $(this);
        var element_height = $element.outerHeight();
        var element_top_position = $element.offset().top;
        var element_bottom_position = element_top_position + element_height;

        if (element_bottom_position >= window_top_position && element_top_position <= window_bottom_position) {
          position = position + 0.5;
          $element.css('transform', 'translateY(' + position + 'px)');
        } else {
          $element.css('transform', 'translateY(0px)');
        }
      });
    }
    lastScrollTop = st;
  }
}

$window.on('scroll resize', check_if_in_view);
$window.trigger('scroll');
var charityBallz = function () {

  var selectors = {
    floating: {
      container: '.charity-ballz__floating',
      small: '.small',
      large: '.large'
    },
    notification: '.charity-notification'
  };

  var classes = {
    slideIn: 'charity-ballz__floating--slide-in',
    notification: {
      visible: 'charity-notification--visible',
      front: 'charity-notification--front'
    }
  };

  var settings = {
    delay: 1000,
    animationDuration: 1000
  };

  function loadFloatingBalls() {
    setTimeout(function () {
      $(selectors.floating.container).addClass(classes.slideIn);

      setTimeout(function () {
        // Let the initial transition run, then remove the transition attribute for smoother scroll down the page
        $(selectors.floating.container).css('transition', 'none');
      }, settings.animationDuration);

      requestAnimationFrame(floatingBalls);
    }, settings.delay);
  }

  function floatingBalls() {
    // Get the current page scroll position
    var newPos = window.pageYOffset / document.body.offsetHeight * 330;

    // Set the elements transform
    $(selectors.floating.container).css('transform', 'translateY(-' + newPos + '%)');
    $(selectors.floating.large).css('top', 80 - newPos + 'vh');

    requestAnimationFrame(floatingBalls);
  }

  function toggleNotification() {
    var hide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var notification = $(selectors.notification);

    if (!hide) {
      notification.addClass(classes.notification.visible);

      setTimeout(function () {
        notification.addClass(classes.notification.front);
      }, 300);
    } else {
      notification.removeClass(classes.notification.visible);

      setTimeout(function () {
        notification.removeClass(classes.notification.front);
      }, 300);
    }
  }

  return {
    init: function init() {
      window.addEventListener('load', function () {
        toggleNotification();
      });

      if ($(selectors.floating.container).length > 0) {
        loadFloatingBalls();
      }
    }
  };
}();

$(function () {
  charityBallz.init();
});

/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = function () {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // var $addressForm = $('.address-form');

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });

    // if (! $addressForm.length) {
    //   return;
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function () {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function () {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function () {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function () {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, { parameters: { _method: 'delete' } });
    }
  });
}();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = function () {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
}();

$(document).ready(function () {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function (evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Wrap videos in div to force responsive layout.
  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }
});